// extracted by mini-css-extract-plugin
export default {"leftRenderer":"leftRenderer--21d2df7f","middleRenderer":"middleRenderer--7421906f","rightRenderer":"rightRenderer--907c3031"};